import SvgIcon, { SvgIcons } from '@ui-components/SvgIcon';
import { trackCustomEvent } from '@utils/statistics/clientStatistics';
import { toggleEpisodePicker } from '@utils/statistics/customEvents';
import React, { useContext } from 'react';
import { VideoPlayerContext } from '../../VideoPlayerContext';
import { StyledToggle } from './EpisodePickerButton.styles';

const EpisodePickerButton: React.FC<{
    playedPercentage: number;
}> = ({ playedPercentage }) => {
    const { displayEpisodePicker, setContext } = useContext(VideoPlayerContext);
    const handleClick = () => {
        setContext('displayEpisodePicker', !displayEpisodePicker);
        trackCustomEvent(toggleEpisodePicker(!displayEpisodePicker, playedPercentage));
    };

    if (displayEpisodePicker) {
        return (
            <StyledToggle onClick={handleClick} displayEpisodePicker>
                <span>Dölj avsnitt</span>
            </StyledToggle>
        );
    }

    return (
        <StyledToggle onClick={handleClick}>
            <SvgIcon icon={SvgIcons.PLAYLIST} width={17} />
            <span>Fler avsnitt</span>
        </StyledToggle>
    );
};

export default EpisodePickerButton;
